import { PluginContainerData } from "./common";
const baseTableData = {};
const TableData = {
  fromJSON(object) {
    const message = { ...baseTableData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.dimensions = object.dimensions !== void 0 && object.dimensions !== null ? TableData_Dimensions.fromJSON(object.dimensions) : void 0;
    message.header = object.header !== void 0 && object.header !== null ? Boolean(object.header) : void 0;
    message.rowHeader = object.rowHeader !== void 0 && object.rowHeader !== null ? Boolean(object.rowHeader) : void 0;
    message.columnHeader = object.columnHeader !== void 0 && object.columnHeader !== null ? Boolean(object.columnHeader) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.dimensions !== void 0 && (obj.dimensions = message.dimensions ? TableData_Dimensions.toJSON(message.dimensions) : void 0);
    message.header !== void 0 && (obj.header = message.header);
    message.rowHeader !== void 0 && (obj.rowHeader = message.rowHeader);
    message.columnHeader !== void 0 && (obj.columnHeader = message.columnHeader);
    return obj;
  }
};
const baseTableData_Dimensions = { colsWidthRatio: 0, rowsHeight: 0, colsMinWidth: 0 };
const TableData_Dimensions = {
  fromJSON(object) {
    const message = { ...baseTableData_Dimensions };
    message.colsWidthRatio = (object.colsWidthRatio ?? []).map((e) => Number(e));
    message.rowsHeight = (object.rowsHeight ?? []).map((e) => Number(e));
    message.colsMinWidth = (object.colsMinWidth ?? []).map((e) => Number(e));
    return message;
  },
  toJSON(message) {
    const obj = {};
    if (message.colsWidthRatio) {
      obj.colsWidthRatio = message.colsWidthRatio.map((e) => Math.round(e));
    } else {
      obj.colsWidthRatio = [];
    }
    if (message.rowsHeight) {
      obj.rowsHeight = message.rowsHeight.map((e) => Math.round(e));
    } else {
      obj.rowsHeight = [];
    }
    if (message.colsMinWidth) {
      obj.colsMinWidth = message.colsMinWidth.map((e) => Math.round(e));
    } else {
      obj.colsMinWidth = [];
    }
    return obj;
  }
};
export {
  TableData,
  TableData_Dimensions
};
//# sourceMappingURL=plugin_table.js.map
